import { Trans, useTranslation } from 'react-i18next';

import { Liip } from './icons/Liip.tsx';

export const Header = () => {
  const { t } = useTranslation();
  return (
    <header className="header">
      <a href="https://www.liip.ch" target="_blank" className="header__liip-link">
        <Liip />
      </a>
      <div className="header__logo">
        <h1 className="header__title">{t('header.title')}</h1>
        {t('header.slogan') && (
          <p className="header__slogan">
            <Trans i18nKey="header.slogan"></Trans>
          </p>
        )}
      </div>
    </header>
  );
};
